module.exports = __webpack_public_path__ + "media/flags/gt-c4ec06d9.svg";